import { FRAGMENT_CARD_PADDING_X, FRAGMENT_LIST_CONTAINER_SX } from '../constants';

/**
 * Shared styles for clickable fragment cards: cursor, border, transition and hover.
 * Used by both grid (FragmentCardBase) and list (FragmentCardListBase) layouts.
 */
export const fragmentCardInteractiveSx = {
  cursor: 'pointer',
  border: '1px solid transparent',
  transition: 'box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out',
  '&:hover': {
    boxShadow: 4,
    borderColor: 'primary.main',
  },
} as const;

/** Grid card layout: full height, column flex, plus interactive styles. */
export const fragmentCardBaseSx = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  ...fragmentCardInteractiveSx,
} as const;

/** Grid card content area padding. */
export const fragmentCardContentSx = {
  flexGrow: 1,
  pb: 1,
  pt: 1.5,
  px: FRAGMENT_CARD_PADDING_X,
} as const;

/** List card layout: row flex, container width, padding, plus interactive styles. */
export const fragmentCardListSx = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'stretch',
  width: '100%',
  ...FRAGMENT_LIST_CONTAINER_SX,
  ...fragmentCardInteractiveSx,
  p: FRAGMENT_CARD_PADDING_X,
  gap: FRAGMENT_CARD_PADDING_X,
} as const;
